import katex from "katex";

/** KaTeX adds the TeX source as an <annotation>; the page needs only the MathML. */
const ANNOTATION = /<annotation[\s\S]*?<\/annotation>/g;

/**
 * A formula typeset with KaTeX as MathML (no stylesheet needed, readable by screen
 * readers, identical on the server and in the browser). `label` is the plain-text form
 * announced when the MathML cannot be, and the fallback if KaTeX refuses the input.
 */
export function MathView({
  latex,
  label,
  block = false,
}: {
  latex: string;
  label: string;
  block?: boolean;
}) {
  let html: string | null = null;
  try {
    html = katex
      .renderToString(latex, {
        displayMode: block,
        output: "mathml",
        throwOnError: true,
        trust: false,
      })
      .replace(ANNOTATION, "");
  } catch {
    html = null;
  }
  if (html === null) {
    return <span className="font-mono">{label}</span>;
  }
  return (
    <span
      className={block ? "block overflow-x-auto text-lg" : "inline-block"}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: KaTeX output with trust off — only MathML elements KaTeX builds, all text escaped by KaTeX.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
